/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_create_drawer_purpose_label = /** @type {(inputs: {}) => string} */ () => {
	return `Propósito`
};

const en_cards_create_drawer_purpose_label = /** @type {(inputs: {}) => string} */ () => {
	return `Purpose`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_create_drawer_purpose_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_create_drawer_purpose_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_create_drawer_purpose_label", locale)
	if (locale === "es") return es_cards_create_drawer_purpose_label(inputs)
	return en_cards_create_drawer_purpose_label(inputs)
};
export { cards_create_drawer_purpose_label as "cards.create_drawer.purpose_label" }